module.exports = __webpack_public_path__ + "static/media/1.981f53ed.svg";